<template>
  <div id="History" class="package-wrapper">
    <div class="add-query">
    <h2>Packages</h2>
    <b-container fluid class="package-container">
        <b-row>
          <b-col lg="12">
            <div class="package-item">
              <h3 class="package-head">Newbie</h3>
              <b-row>
                <b-col lg="12">
                  <b>Q:</b> <span>200</span>
                </b-col>
                <b-col lg="12">
                  <b>R:</b> <span>5000/-</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col lg="12">
                  <b>Add on:</b>
                  <p>- Tables upto 250</p>
                  <p>- Squares upto 250</p>
                  <p>- Cubes upto 250</p>
                  <p>- Unit Sheet</p>
                </b-col>
              </b-row>
              <b-row>
                <b-col lg="12">
                  <b>Description</b>
                  <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
  tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
  quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
  consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse
  cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non
  proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
                </b-col>
              </b-row> 
              <b-button to="#" class="query-btn" variant="primary">Know More</b-button>
            </div>
          </b-col>
        </b-row>
      </b-container>
  </div>
  </div>
</template>

<script>
export default {
  name: 'PackageHistory',
  data () {
    return {
      msg: 'Welcome to QdsPro',
      form: {
        qtitle:'',
        selected: null,
        doubt:''
      }
    }
  },
  methods: {
    onSubmit() {
      console.log('submitted');
      this.$router.push('/dashboard');
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.add-query h2 {
  color:#262e3b;
  text-transform: uppercase;
  font-weight: bold;
  padding:20px 0;
  border-bottom:1px solid #e5e5e5;
  width:90%;
  margin:0 auto;
}
.package-container {
  width:90%;
  margin:50px auto 0;
}
.package-head {
  border-bottom:1px solid #efefef;
  color:#AACF37;
  font-weight:bold;
}
.package-item a {
  border-radius:10px;
}
.package-item p {
  margin:0;
}
.package-item .row,.package-item a {
  margin-top:20px;
  margin-bottom:20px;
}
.package-container .col-lg-4 {
  margin-bottom:30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/PackagesHistory.vue